import React from 'react';

const Step2Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-2">
            Richiedi subito il tuo preventivo online con la detrazione fiscale
            fino al 50%.
        </div>
    );
};

export default Step2Infos;
